'use strict'

import { codeData } from '../utils/codeData';

const individual = {
    path: 'sign-details',
    name: 'sign-details',
    meta: {
        title: '签约管理-签约管理-综合服务平台',
        name: '签约管理',
        tagsTitle: '签约管理',
        code: ''
    },
    redirect: {
        name: 'sign-details-list'
    },
    component: () => import('@/components/RouterView'),
    children: [
        {
            path: 'list',
            name: 'sign-details-list',
            meta: {
                title: '签约管理-签约管理-综合服务平台',
                name: '',
                tagsTitle: '签约管理',
                code: ''
            },
            component: () => import('@/pages/sign/SignDetails'),
        }
    ]
};

export default individual;